import { Component} from '@angular/core';

@Component({
  templateUrl: './too-many-requests.component.html',
  styleUrls: ['./too-many-requests.component.scss']
})

export class TooManyRequestsComponent {
  constructor() { }
}
